import { z } from 'zod';

export const SupplementalDatasetType = z
  .enum(['external_pay_benchmarking', 'internal_pay_benchmarking', 'resumes'])
  .describe('SupplementalDatasetType');
export type SupplementalDatasetType = z.infer<typeof SupplementalDatasetType>;

export const SupplementalDatasetTypes = Object.values(
  SupplementalDatasetType.Values,
);

export const SupplementalDatasetStatus = z.object({
  type: SupplementalDatasetType,
  status: z.enum(['missing', 'uploaded']),
});

export type SupplementalDatasetStatus = z.infer<
  typeof SupplementalDatasetStatus
>;

export const SupplementalDatasetTypeMeta = z.object({
  type: SupplementalDatasetType,
  key: z.string(),
});

export type SupplementalDatasetTypeMeta = z.infer<
  typeof SupplementalDatasetTypeMeta
>;

export const SupplementalDatasetTypeMetas: SupplementalDatasetTypeMeta[] = [
  {
    type: 'external_pay_benchmarking',
    key: 'external_pay_benchmarking',
  },
  {
    type: 'internal_pay_benchmarking',
    key: 'internal_pay_benchmarking',
  },
];

export const UploadSupplementalDatasetRequest = z.object({
  type: SupplementalDatasetType,
});

export type UploadSupplementalDatasetRequest = z.infer<
  typeof UploadSupplementalDatasetRequest
>;

export const UploadSupplementalDatasetUrlResponse = z.object({
  url: z.string(),
});

export type UploadSupplementalDatasetUrlResponse = z.infer<
  typeof UploadSupplementalDatasetUrlResponse
>;

export const GetSupplementalDatasetStatusesResult = z.object({
  statuses: z.array(SupplementalDatasetStatus),
});

export type GetSupplementalDatasetStatusesResult = z.infer<
  typeof GetSupplementalDatasetStatusesResult
>;

export const PayBand = z
  .object({
    min: z.number().min(0),
    max: z.number().min(0),
  })
  .describe('PayBand');

export type PayBand = z.infer<typeof PayBand>;
